/**
 * Genera un archivo TXT con la info de la cuenta y lo descarga.
 * Usado al crear cuenta, recuperar password y cambiar password.
 *
 * Los textos de marca/instrucciones vienen del CMS (account.backup).
 */

const BACKUP_DEFAULTS = {
  file_title: "CUENTA DEL SERVIDOR",
  intro_register: "Bienvenido. Guarda este archivo en un lugar seguro!",
  intro_recover: "Tu contraseña fue restablecida correctamente.",
  intro_change: "Tu contraseña fue actualizada correctamente.",
  instructions:
    "1. Guarda este archivo en un lugar seguro (NO en la nube publica).\n" +
    "2. Tu password queda registrada en el servidor del juego.\n" +
    "3. Si pierdes el acceso, podras recuperar la cuenta con tu email y la\n" +
    "   respuesta a tu pregunta secreta desde la pagina de login.\n" +
    "4. Nunca compartas tu password ni tu respuesta secreta con nadie.\n" +
    "5. El staff del servidor NUNCA te pedira tu password.",
  server_label: "Servidor:",
  server_url: "",
  support_label: "Soporte:",
  support_contact: "",
  filename_prefix: "cuenta",
};

export function downloadAccountBackup({ action, account, password, email, question, answer, meta, texts }) {
  const t = { ...BACKUP_DEFAULTS, ...(texts || {}) };

  const intro =
    action === "register"
      ? t.intro_register
      : action === "recover"
      ? t.intro_recover
      : t.intro_change;

  const now = new Date(meta?.timestamp || Date.now()).toLocaleString("es-AR", {
    dateStyle: "full",
    timeStyle: "medium",
  });

  const title = (t.file_title || BACKUP_DEFAULTS.file_title).toUpperCase();

  const banner = `=================================================================
                    ${title}
=================================================================
${intro}
=================================================================

`;

  const sections = [];

  sections.push(`>>> CREDENCIALES DE INGRESO
Usuario:       ${account}
${password ? `Password:      ${password}` : ""}
${email ? `Email:         ${email}` : ""}`);

  if (question || answer) {
    sections.push(`>>> RECUPERACION DE CUENTA
Pregunta:      ${question || "(sin cambios)"}
Respuesta:     ${answer || "(sin cambios)"}`);
  }

  sections.push(`>>> METADATOS DEL EVENTO
Accion:        ${
    action === "register"
      ? "Registro de cuenta"
      : action === "recover"
      ? "Recuperacion de contrasena"
      : "Cambio de contrasena"
  }
Fecha:         ${now}
IP:            ${meta?.ip || "—"}
Pais / Region: ${meta?.country || "—"} / ${meta?.region || "—"}
Ciudad:        ${meta?.city || "—"}
Navegador:     ${meta?.user_agent || navigator.userAgent || "—"}`);

  const instructionLines = (t.instructions || "")
    .split("\n")
    .map((line) => line.trimEnd())
    .filter((line) => line.length > 0)
    .join("\n");

  const footer = [];
  if (t.server_url) {
    footer.push(`${t.server_label || "Servidor:"} ${t.server_url}`);
  }
  if (t.support_contact) {
    footer.push(`${t.support_label || "Soporte:"} ${t.support_contact}`);
  }

  sections.push(
    `>>> INSTRUCCIONES\n${instructionLines}${
      footer.length ? "\n\n" + footer.join("\n") : ""
    }\n=================================================================`
  );

  const content = banner + sections.join("\n\n") + "\n";

  const prefix = (t.filename_prefix || "cuenta").replace(/[^a-z0-9_-]/gi, "_").toLowerCase() || "cuenta";
  const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${prefix}_${action}_${account}_${Date.now()}.txt`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
